import { Alert, Button } from 'antd'
import Status from '../../../elements/Status'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'

const CheckboxTable = checkboxHOC(CustomTable)

const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 100,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/cargo/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  { Header: 'Title', accessor: 'title' },
  {
    Header: 'Locked',
    accessor: 'locked',
    Cell: ({ value }) => <Status value={value ? 'Locked' : 'Available'} tooltip={false} />,
  },
  {
    Header: 'Current Route',
    accessor: 'routes',
    Cell: ({ value }) => {
      const remainingRoutes = value.filter((r) => r.hasFreightBooking === false)
      if (remainingRoutes.length <= 0) return '__Final Destination__'
      const currentRoute = remainingRoutes.sort((r) => r.index)[0]
      if (currentRoute) {
        // label
        console.log({ currentRoute })
        const fromLocation = currentRoute.start.location
        const fromLabel = `[${fromLocation.location}]`
        const toLocation = currentRoute.end.location
        const toLabel = `[${toLocation.location}]`
        return <span>{`From ${fromLabel} to ${toLabel}.`}</span>
      } else {
        return '__ERROR__'
      }
    },
  },
  { Header: 'Status', accessor: 'status', Cell: StatusCell },
]

function CargoList(props) {
  const {
    list,
    fetch,
    fetching,
    selectAll,
    isSelected,
    toggleSelection,
    selectionRawData,
    selectionData,
    toggleAll,
    tableRef,
    selection,
    onShow,
  } = props

  const checkboxProps = {
    selectType: 'checkbox',
    selectAll,
    isSelected,
    toggleSelection,
    toggleAll,
  }
  return (
    <div>
      {selectionRawData.some((i) => i.locked || i.status !== 'Confirmed') && (
        <Alert message="You can't create a FB with a Locked/Cancelled or Closed Cargo" type="error" showIcon />
      )}
      <CheckboxTable
        {...checkboxProps}
        withRef={tableRef}
        data={selectionData}
        defaultPageSize={20}
        isFilterable={true}
        fetching={fetching}
        fetch={fetch}
        columns={columns}
        CreateButton={() => (
          <Button
            type={'primary'}
            size="small"
            icon={'plus'}
            // disabled={selection.length === 0 || selectionRawData.some((i) => i.locked || i.status === 'Closed')}
            onClick={onShow}>
            Create Freight Booking
          </Button>
        )}
        defaultSorted={[
          {
            id: '_key',
            desc: true,
          },
        ]}
      />
    </div>
  )
}

CargoList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
CargoList.defaultProps = {}

export default withRouter(CargoList)
